import { Module } from 'vuex';
import { PlayStateEnum, WsStateTypes } from './types';
import RootStateTypes from '../../types';
import { buildRequestDataToBytes } from '@/proto/helper.js';
import { dayjs } from 'element-plus';
import { store } from '../../index';
import { freeze } from '@/utils/utils';
import { LinkedList } from '@/utils/linkedlist';
import { useHostConfigStore } from '@/store/hostConfigStore'; 
let playTimer: any = null;

export const get_channel_list_no_checked = ({
  modelMapTreeChecked,
  allChannelList,
}: any) => {
  let channel_list_no_checked = null;
  if (allChannelList.length) {
    let modelMapTreeCheckedStr = JSON.stringify(modelMapTreeChecked);
    channel_list_no_checked = allChannelList.filter(
      (v: any) => !modelMapTreeCheckedStr.includes(v),
    );
  }
  return channel_list_no_checked;
};
const wsModule: Module<WsStateTypes, RootStateTypes> = {
  namespaced: true,
  state: {
    wsBaseUrl:'',
    vehicleInfo: {},
    playLoading: null,
    cameraInfo: [],
    moduleLists: [],
    currentModule: [],
    allMapData: null,
    isSelectpoint: false,
    totalLength: 0,
    timeout: 5 * 1000,
    recordLists: {},
    // ---播放列表长链接
    dirWs: null,
    dirWsTimer: null,
    dirTask: [],
    // ---报长链接
    ws: null,
    wsTimer: null,
    wsReloadCount: 0,
    // ---播报数据
    list: [],
    listIndex: -1,
    allData: [],
    allData_len: 0,
    allData_index: 0,
    speed: 1,
    timer: null,
    // 当前帧
    data: {},
    isJump: 1,
    allChannelList: [],
    currentChannelList: [],

    //data webmonitor
    vehicleId: '',
    business_id: '',
    cars: [],
    playbackState: 1, //0-播放 1-跳转 -1-暂停
    playlist: [], //可播放时间段
    createTimestamp: 0, //当前帧时间戳 ms
    playcache: new LinkedList(), //本地缓存
    startts: 0, //当前播放的时间段的开始时间戳 ms
    playIntervalTs: { pre: 0, next: 0 }, //当前播放定时器
    serverSendState: 0, //0send 1pause
    initTs: 0,
    wsstate: -1, //-1-无连接 0-开始连接 100-连接成功 200-播放列表返回 300-开始播放 400-连接关闭v   todo
    playItem: [],
    playTimeMiss: [],
    nextFrameMode: false,
    prevCache: [], // 已播放的缓存,
    prevFlag: 0,
    nextFlag: 0,
    isTimeRangeNoData: false,    
  },
  // 同步放mutations
  mutations: {
    pause(state) {
      state.playbackState = PlayStateEnum.pause;
    },
    clearCache(state) {
      state.playcache.clear();
    },
    clearPrevCache(state) {
      state.prevCache = [];
    },
    resume(state) {
      state.playbackState = PlayStateEnum.play;
    },
    //data webmonitor end
    setStartts(state, data) {
      state.startts = data.startTs; // todo 
      state.playIntervalTs = {
        pre: parseInt(data.startTs),
        next: parseInt(data.endTs),
      };
    },
    setPlayItem(state, data) {
      state.playItem = data.playItem;
      state.playTimeMiss = data.playTimeMiss;
    },
    setNextFrameMode(state, data) {
      state.nextFrameMode = data;
    },
    setWsstate(state, data) {
      state.wsstate = data;
    },
    setInitTs(state, data) {
      state.initTs = data;
    },
    setVehicleId(state, data) {
      state.vehicleId = data;
    },
    setBusinessId(state, data) {
      state.business_id = data;
    },
    setCars(state, data) {
      state.cars = data;
    },
    setCurrentChannelList(state, list) {
      state.currentChannelList = freeze(list);
    },
    setAllChannelList(state, list) {
      state.allChannelList = freeze(list);
    },
    changeDirTask(state, dirTask) {
      state.dirTask = dirTask;
    },
    setWsBaseUrl(state, url) {
      localStorage.setItem('wsBaseUrl', url);
      state.wsBaseUrl = url;
    },
    setModuleLists(state, data) {
      state.moduleLists = freeze(data);
    },
    setCurrentModule(state, data) {
      state.currentModule = data;
    },
    setCameraInfo(state, data) {
      state.cameraInfo = freeze(data.map((item: any) => item[1].humanName));
    },
    setPlayList(state, list) {
      state.playlist = list;
    },
    WS_LIST(state, data) {
      state.list = freeze(data);
    },
    setVehicleInfo(state, data) {
      state.vehicleInfo = freeze(data);
    },
    setTotalLength(state, length) {
      state.totalLength = freeze(length);
    },
    WS_DATA(state, data) {
      state.data = freeze(data);
    },
    WS_ALL_DATA(state, data) {
      state.allData = freeze([...state.allData, data]);
    },
    WS_ALL_DATA_INDEX(state, data) {
      if (typeof data === 'number') {
        state.allData_index = data;
        state.isJump = +new Date();
      } else {
        state.allData_index += 1;
      }
    },

    WS_SET_PLAYLIST(state, playlist) {
      state.playlist = playlist;
    },
    setSpeed(state, speed) {
      state.speed = speed;
    },
    setMapAllData(state, data) {
      state.allMapData = data;
    },
    setSelectpoint(state, data) {
      state.isSelectpoint = data;
    },
    setCreateTimestamp(state, ts) {
      state.createTimestamp = ts;
    },
    changePrevFlag(state) {
      state.prevFlag += 1;
    },
    changeNextFlag(state) {
      state.nextFlag += 1;
    },
    setIsTimeRangeNoData(state, data) {
      state.isTimeRangeNoData = data;
    },

  },
  // 异步放actions
  actions: {
    checkCache({ commit, state, dispatch }) {
      if (state.playcache.size() > 2000) {
        if (state.serverSendState == 0) {
          //pause
          dispatch('WS_SendAction', 1);
          state.serverSendState = 1;
        }
      } else if (state.playcache.size() < 100) {
        if (state.serverSendState == 1) {
          //continue
          dispatch('WS_SendAction', 0);
          state.serverSendState = 0;
        }
      }
    },
    WS_INIT({ commit, state }, initTs) {

    },
    WS_SendProgress({ commit, state, dispatch }, progress) {
      //清空缓存
      // state.playbackState = PlayStateEnum.jump;

      state.playIntervalTs = {
        pre: parseInt(progress),
        next: parseInt(progress) + 100,
      };

    },
    WS_SendAction({ commit, state, dispatch }, action) {
      let map = new Map();
      map.set('action', action + '');
      let bytes = buildRequestDataToBytes(
        '1002',
        '/live_mode/send_action',
        map,
        0,
      );
      state.ws?.send(bytes);
    },
    WS_SendProgress_init({ commit, state, dispatch }, { startTs, endTs }) {


      //清空缓存
      state.playcache.clear();
      state.playbackState = PlayStateEnum.jump;
      state.playIntervalTs = {
        pre: parseInt(startTs),
        next: parseInt(startTs) + 100,
      };


      let map = new Map();

      map.set('play_pos', startTs + '');
      map.set('end_pos', endTs + '');

      let bytes = buildRequestDataToBytes(
        '1002',
        '/live_mode/send_progress',
        map,
        0,
      );

      function send() {
        store.commit('setLoadingText', {text:'等待数据'});

        if (state.ws.readyState === WebSocket.CONNECTING) {
          setTimeout(() => {
            send();
          }, 2000);
        } else if (state.ws.readyState === WebSocket.OPEN) {
          state.ws.send(bytes);
        } else if (
          [WebSocket.CLOSING, WebSocket.CLOSED].includes(state.ws.readyState)
        ) {
          dispatch('WS_INIT', startTs);
        }
      }

      send();
    },
  },
};

export default wsModule;
